import { CSSProperties } from "react";
import "./VideoEmbed.scss";

type VideoEmbedProps = {
	src: string;
	width?: string;
	height?: string;
	aspectRatio?: string;
	title?: string;
};

const YoutubeVideo = ({
	src,
	title,
}: Pick<VideoEmbedProps, "src" | "title">) => {
	return (
		<iframe
			width="100%"
			height="100%"
			src={src}
			title={title || "Youtube video player"}
			frameBorder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			referrerPolicy="strict-origin-when-cross-origin"
			allowFullScreen></iframe>
	);
};

const VideoEmbed = ({
	src,
	width,
	height,
	aspectRatio,
	title,
}: VideoEmbedProps) => {
	return (
		<section
			className="video-embed"
			style={
				{
					"--aspect-ratio": aspectRatio || `${width || 16} / ${height || 9}`,
					"--video-width": width,
					"--video-height": height,
				} as CSSProperties
			}>
			<YoutubeVideo src={src} title={title} />
		</section>
	);
};

export default VideoEmbed;
